import type { Color } from 'minerva-plugin-api';

export class DataOverlayEntry {
  bioEntityId: number;

  bioEntityType: string;

  bioEntityModelId: number;

  /** @deprecated use {@link DataOverlayEntry.colorRgba} */
  color: Color | null;

  colorRgba: string | null;

  value: number | null;

  constructor(
    bioEntityId: number,
    bioEntityType: string,
    bioEntityModelId: number,
    color: Color | null,
    colorRgba: string | null,
    value: number | null,
  ) {
    this.bioEntityId = bioEntityId;
    this.color = color;
    this.colorRgba = colorRgba;
    this.value = value;
    this.bioEntityType = bioEntityType;
    this.bioEntityModelId = bioEntityModelId;
  }
}
